import { render, staticRenderFns } from "./友情链接2.vue?vue&type=template&id=407419c2&scoped=true"
import script from "./友情链接2.vue?vue&type=script&lang=js"
export * from "./友情链接2.vue?vue&type=script&lang=js"
import style0 from "./友情链接2.vue?vue&type=style&index=0&id=407419c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407419c2",
  null
  
)

export default component.exports